import { ContextFormFieldNumber } from '@bambi/component-library/src/components/forms/context/ContextFormFieldNumber';

import { CurrencyFormContextField } from 'src/common/FormField/CurrencyFormContextField';
import { useFormValues } from 'src/common/useFormValues';

import type { SchemeConfigFormValues } from '../PricingWizardSchemeConfigurationStep';

export function NoShowAmountField() {
  const cancelFeeType =
    useFormValues<SchemeConfigFormValues>().no_show_fee_type;
  return cancelFeeType === 'Percentage' ? (
    <ContextFormFieldNumber
      fieldPath="no_show_fee_percentage"
      label="No Show Fee (Percentage)"
      inline
      helperText="Enter the percentage of the trip cost that will be charged for no shows."
      rules={{
        validate: (value) => {
          if (!Number.isInteger(Number(value))) {
            return 'Percentage must be an integer';
          }
          if (value < 0 || value > 100) {
            return 'Percentage must be between 0 and 100';
          }
          return true;
        },
      }}
    />
  ) : (
    <CurrencyFormContextField
      fieldPath="no_show_fee_cents"
      label="No Show Fee"
      inline
      helperText="Enter the fee charged for no shows."
    />
  );
}
